import React, { useEffect } from 'react';
import Select from 'react-select';
import cn from 'classnames';
import CustomControl from '../../../CustomControl/CustomControl';
import GroupSelect from './GroupSelect';
import Hint from '../../../Hint/Hint';
import { FMessage } from '../../../../hoc/IntlComponents';
import { tooltipData } from '../../../../fixtures/features';
import { STATIC_PATH } from '../../../../config';

const NewFeature = ({
  id,
  parentPath,
  className,
  available,
  stateOfThings: state,
  handleChange,
  handleGroupChange,
  handleGroupSelectChange,
  type,
  title,
  list,
  input_type,
  fields,
  default: defaultValue,
  placeholder,
  onCheck,
  onUnCheck,
  handleSettingsModification,
  currentLandingSettingsOverrides,
}) => {
  const path = `${parentPath}${id ? `/${id}` : ''}`;

  const overrides = currentLandingSettingsOverrides && currentLandingSettingsOverrides[path];

  // set default value on mount
  useEffect(() => {
    if (state[path] === undefined) {
      switch (type) {
        // case 'checkbox':
        //   handleChange(path, '0');
        //   break;
        case 'group':
        case 'landing_setting':
          handleChange(path, false);
          break;
        // case 'select':
        // case 'text':
        case 'group-select':
          break;

        default:
          handleChange(path, defaultValue);
      }
    }
  }, []);

  // modifications on checkboxes
  useEffect(() => {
    if (onCheck && state[path] === true) {
      handleSettingsModification((prev) => ({ ...prev, ...onCheck }));
    }
    if (onUnCheck && state[path] === false) {
      handleSettingsModification((prev) => ({ ...prev, ...onUnCheck }));
    }
  }, []);

  const handleModificationChange = (checked) => {
    if (checked && onCheck) {
      return handleSettingsModification((prev) => ({ ...prev, ...onCheck }));
    }
    if (!checked && onUnCheck) {
      handleSettingsModification((prev) => ({ ...prev, ...onUnCheck }));
    }
  };

  return (
    <>
      {type === 'group' && (
        <CustomControl
          id={path}
          label={title}
          className={cn('custom-control-xs', className)}
          onChange={(e) => handleGroupChange(path, e.target.checked)}
          value="1"
          // state[path] may be "1"
          checked={!!state[path] || false}
          disabled={overrides ? !overrides.available : false}
        />
      )}
      {type === 'checkbox' && (
        <>
          <CustomControl
            id={path}
            label={title}
            className={cn('custom-control-xs', className)}
            onChange={(e) => {
              handleModificationChange(e.target.checked);
              handleChange(path, e.target.checked ? '1' : '0');
            }}
            value="1"
            checked={(state[path] && state[path] === '1') || false}
            disabled={overrides ? !overrides.available : !available}
          />
          {tooltipData[path] && (
            <Hint
              title={title}
              id={`hint-${id}`}
              placement="bottom"
              popoverClassName="feature-hint-popover"
            >
              <FMessage id={tooltipData[path].desc} />
              <img
                src={`${STATIC_PATH}/img/flow-feature-previews/${id}.png`}
                className="feature-hint-preview-img"
              />
            </Hint>
          )}
        </>
      )}
      {type === 'landing_setting' && (
        <>
          <CustomControl
            id={path}
            label={title}
            className={cn('custom-control-xs', className)}
            onChange={
              fields?.length
                ? (e) => {
                    handleModificationChange(e.target.checked);
                    handleGroupChange(path, e.target.checked);
                  }
                : (e) => {
                    handleModificationChange(e.target.checked);
                    handleChange(path, e.target.checked);
                  }
            }
            value="1"
            checked={state[path] || false}
            disabled={overrides ? !overrides.available : !available}
          />
          {tooltipData[path] && (
            <Hint
              title={title}
              id={`hint-${id}`}
              placement="bottom"
              popoverClassName="feature-hint-popover"
            >
              <FMessage id={tooltipData[path].desc} />
              <img
                src={`${STATIC_PATH}/img/flow-feature-previews/${id}.png`}
                className="feature-hint-preview-img"
              />
            </Hint>
          )}
        </>
      )}
      {type === 'select' && (
        <>
          {title ? <label className="features-control-label">{title}</label> : null}
          <Select
            placeholder={placeholder ?? title}
            className={cn('features-control', 'features-control--select', 'Select--sm', className)}
            clearable={false}
            options={Object.keys(list).map((v) => ({ value: v, label: list[v] }))}
            onChange={(v) => handleChange(path, v.value)}
            value={state[path] || null}
            isDisabled={overrides ? !overrides.available : !available}
          />
        </>
      )}
      {type === 'text' && (
        <div className={cn('features-control-text-input-wrapper', className)}>
          <div className="d-flex">
            {title ? <label className="features-control-label">{title}</label> : null}
            {tooltipData[path] && (
              <Hint
                title={title}
                id={`hint-${id}`}
                placement="bottom"
                popoverClassName="feature-hint-popover"
              >
                <FMessage id={tooltipData[path].desc} />
                {tooltipData[path].preview ? (
                  <img
                    src={`${STATIC_PATH}/img/flow-feature-previews/${path}.png`}
                    className="feature-hint-preview-img"
                  />
                ) : null}
              </Hint>
            )}
          </div>
          <input
            className="features-control-text-input form-control"
            type={input_type}
            onChange={(e) => handleChange(path, e.target.value)}
            value={state[path] || defaultValue}
            disabled={overrides ? !overrides.available : !available}
          />
        </div>
      )}
      {type === 'group-select' && (
        <GroupSelect
          title={title}
          placeholder={placeholder}
          className={className}
          fields={fields}
          state={state}
          path={path}
          handleChange={handleChange}
          handleGroupSelectChange={handleGroupSelectChange}
          handleSettingsModification={handleSettingsModification}
          currentLandingSettingsOverrides={currentLandingSettingsOverrides}
          disabled={overrides ? !overrides.available : !available}
        />
      )}
      {type !== 'group-select' && fields && state[path] ? (
        <ul className="feature-list">
          {fields.map((el) => (
            <li key={el.title}>
              <NewFeature
                {...el}
                handleChange={handleChange}
                handleGroupChange={handleGroupChange}
                handleGroupSelectChange={handleGroupSelectChange}
                handleSettingsModification={handleSettingsModification}
                stateOfThings={state}
                parentPath={path}
                currentLandingSettingsOverrides={currentLandingSettingsOverrides}
              />
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
};

export { NewFeature };
